/* eslint-disable */
import format from 'date-fns/format';

/**
 * Wrapper for date-fns/startOfToday to return the actual date today.
 * @param {string} formatString The format string
 * @param {any} options The options object
 * @returns {Date} Today's date
 */
const startOfToday = (formatString = `YYYY-MM-DD`, options = {}) => new Date(`${format(new Date().toString(), formatString, options)}T00:00:00.000Z`);

export default startOfToday;
